/*
These functions make sure WordPress
and Foundation play nice together.
*/
// Trigger hamburger animation
jQuery(document).ready(function($) {
    $(".menu-hamburger-wrap").click(function() {
        $("body").toggleClass("top-menu-active");
    }) 
});